import React from "react";

import { Link } from "react-router-dom";
import {
  cardVagasStyle,
  descCardVagasStyle,
  cardVagasWIconStyle,
  svgCard,
} from "./card-vagas.css";

export function CardVagas({ linkTo, label, description, withIcon, onClick }) {
  return withIcon ? (
    <Link
      aria-label={label}
      to={linkTo}
      className={cardVagasWIconStyle}
      onClick={onClick}
    >
      <svg
        className={svgCard}
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
      >
        <path
          d="M13.9998 0.666504C6.64784 0.666504 0.666504 6.64784 0.666504 13.9998C0.666504 21.3518 6.64784 27.3332 13.9998 27.3332C21.3518 27.3332 27.3332 21.3518 27.3332 13.9998C27.3332 6.64784 21.3518 0.666504 13.9998 0.666504ZM20.6665 15.3332H15.3332V20.6665H12.6665V15.3332H7.33317V12.6665H12.6665V7.33317H15.3332V12.6665H20.6665V15.3332Z"
          fill="#2DAC3A"
        />
      </svg>
      {label}

      {description !== "" ? (
        <span className={descCardVagasStyle}>{description}</span>
      ) : (
        ""
      )}
    </Link>
  ) : (
    <Link aria-label={label} to={linkTo} className={cardVagasStyle}>
      {label}
      {description !== "" ? (
        <span className={descCardVagasStyle}>{description}</span>
      ) : (
        ""
      )}
    </Link>
  );
}
